import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import styled from 'styled-components'

export const AccommodationSameRoomTileOptions = styled.div`
  padding: 0 ${rem(20)} ${rem(20)} ${rem(20)};
  min-width: 0;

  ${mediaQueryUp.tablet} {
    padding: 0;
  }
`
